import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Info } from 'autogen/translation-keys/trans-website-imagealttext-icons';
import { Sponsored } from 'autogen/translation-keys/trans-website-productlists-labels';
import { InlineButtonWithIcon } from 'components/generic/InlineButton';
import Icon from 'components/Icon';
import useSponsoredSplashQuickView from './hooks/useSponsoredSplashQuickView';

type SponsoredSplashProps = {
    productId?: number;
};

export const sponsoredSplashHeight = '24px';

const StyledInlineButtonWithIcon = styled(InlineButtonWithIcon)`
    min-height: ${sponsoredSplashHeight};
    color: ${({ theme }) => theme.ColorTextSecondary};
    line-height: 1em;
`;

export default function SponsoredSplash({ productId, ...restProps }: SponsoredSplashProps): JSX.Element {
    const [, toggle] = useSponsoredSplashQuickView();
    const { t } = useTranslation();

    return (
        <StyledInlineButtonWithIcon
            variant="inherit"
            type="button"
            icon={<Icon type="Information" size={16} />}
            iconProperties={{ position: 'right' }}
            onClick={() =>
                toggle({
                    isOpen: true,
                    productId: productId
                })
            }
            aria-label={`${t(Sponsored)} ${t(Info)}`}
            {...restProps}
        >
            {t(Sponsored)}
        </StyledInlineButtonWithIcon>
    );
}
